export const APP_CONFIG = {
  APP_NAME: import.meta.env.VITE_APP_NAME || 'PROVATIO',
  APP_FULL_NAME: import.meta.env.VITE_APP_FULL_NAME || 'PROVATIO – Plataforma Nacional de Gestão Pericial',
  APP_SHORT_DESCRIPTION: 'Sistema de Gestão Pericial',
  COMPANY_NAME: 'PROVATIO',
  SUPPORT_EMAIL: 'suporte@provatio.com.br',
  WEBSITE: 'www.provatio.com.br',
  LOGO_URL: '/provatio-logo.png'
};

export const MODULES = {
  ADMIN: `${APP_CONFIG.APP_NAME} Admin`,
  ACADEMY: `${APP_CONFIG.APP_NAME} Academy`,
  CERTIFICATION: `${APP_CONFIG.APP_NAME} Certificação`,
  LABS: `${APP_CONFIG.APP_NAME} Labs`,
  RESEARCH: `${APP_CONFIG.APP_NAME} Research`
};